export const DOCUMENT_TYPE_SERVICE_CATEGORY = 'serviceCategory';
